export const GENERATE_URL_REQUEST = 'GENERATE_URL_REQUEST';
export const GENERATE_URL_SUCCESS = 'GENERATE_URL_SUCCESS';
export const GENERATE_URL_FAILED = 'GENERATE_URL_FAILED';



// WEBPACK FOOTER //
// ./src/store/modules/publishing/mutation-types.js